import React from 'react'
import './Style.css'

export default function Section6() {
    return (
        <>
            <section className="section6">
                <div className="map-container">
                    <iframe
                        src="https://www.google.com/maps/embed?pb=!1m18!1m12!1m3!1d1779.311768097954!2d75.74516125516818!3d26.883699401310437!2m3!1f0!2f0!3f0!3m2!1i1024!2i768!4f13.1!3m3!1m2!1s0x396db5a9d44a1535%3A0x41c04bb9bf7a2bee!2sChauhan%20Bhawan!5e0!3m2!1sen!2sin!4v1672624552830!5m2!1sen!2sin"
                        className='map' allowFullScreen="" loading="lazy"
                        referrerPolicy="no-referrer-when-downgrade"></iframe>
                </div>
                <div className="s6-text-container">
                    <div className="s6-text">There Goes Our Location On the Map</div>
                    
                </div>
            </section>
            <hr className='hr' />
        </>
    )
}
